module.exports = __webpack_public_path__ + "img/puzzle_32.4284ce24.png";